import React from "react";
import { Checkbox } from "primereact/checkbox";
import Select from "react-select";
import moment from "moment";
import { capitalize } from "../../lib/helper";
import useTranslation from "../../i18n/useTranslation";
import { formatDate, formatWeekday } from "../../i18n/dates";

const SchedulerHeader = ({
   week,
   copyMode,
   areDayTasksSelected,
   handleDayTasksSelection,
   setLeadingDay
}) => {
   const { t, locale } = useTranslation();

   const options = week.map((optionDay) => ({
      value: optionDay,
      label: capitalize(formatWeekday(optionDay, locale))
   }));

   return week.map((day, index) => {
      const momentDay = moment(day);
      if (!momentDay.isValid()) return false;

      if (index === 0) {
         return (
            <th key={`header-${index}`} className="leading-day">
               {copyMode && (
                  <Checkbox
                     checked={areDayTasksSelected(day)}
                     onChange={() => handleDayTasksSelection(day)}
                     className="mb-2"
                  />
               )}
               <Select
                  value={options.find((option) => option.value === day)}
                  options={options}
                  onChange={setLeadingDay}
                  placeholder={t("common.selectDay")}
                  isClearable={false}
                  isSearchable={false}
                  classNamePrefix="Select"
                  className="Select"
                  components={{
                     IndicatorSeparator: () => null
                  }}
               />
               <p>{formatDate(day)}</p>
            </th>
         );
      }

      return (
         <th key={`header-${index}`}>
            <div className="flex flex-column align-items-center">
               {copyMode && (
                  <Checkbox
                     checked={areDayTasksSelected(day)}
                     onChange={() => handleDayTasksSelection(day)}
                     inputId={`header-${index}`}
                     className="mb-2"
                  />
               )}
               <label htmlFor={`header-${index}`}>
                  {capitalize(formatWeekday(day, locale))}
                  <p>{formatDate(day)}</p>
               </label>
            </div>
         </th>
      );
   });
};

export default SchedulerHeader;
